// extracted by mini-css-extract-plugin
export default {"header":"Statline_header__FlRQr"};